export default "__VITE_ASSET__26ac6366__"